module.exports = __webpack_public_path__ + "img/big_ico_campaign@2x.63c2ffb6.png";